<template>
  <v-app id="inspire">
    <SideBar v-if="showShell" v-model="drawer" />
    <v-main>
      <div class="app-content">
        <TopBar v-if="showShell" @drawerEvent="drawer = !drawer" @logout="handleLogout" />
        <router-view></router-view>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import SideBar from "./common/Sidebar/SideBar";
import TopBar from "./common/Topbar/TopBar";
import { fetchMe } from "@/api/session";
import { fetchMyWork, hasWorkQueue, uniqueByRequest } from "@/views/approval/queue";

export default {
  name: "App",
  components: { TopBar, SideBar },
  data: () => ({
    drawer: null,
  }),
  computed: {
    isLoginPage() {
      return this.$route.name === "login";
    },
    showShell() {
      return !this.isLoginPage && this.$store.getters.isLoggedIn && !!this.$store.getters.getUser;
    },
  },
  watch: {
    // after login and on every reload: fresh role/departments, and the number waiting in Aprobare
    showShell: {
      immediate: true,
      handler(on) {
        if (on) this.refreshSession();
      },
    },
    // Acasă and Aprobare load the queue themselves and set the count; don't fetch it twice there
    $route(to) {
      if (this.showShell && !this.pageLoadsQueue(to)) this.refreshApprovalCount();
    },
  },
  mounted() {
    // a notification said something new waits for this person (helper.setupWebSocket)
    this.$root.$on("approval-queue-changed", this.onQueueChanged);
  },
  beforeDestroy() {
    this.$root.$off("approval-queue-changed", this.onQueueChanged);
  },
  methods: {
    onQueueChanged() {
      // Aprobare reloads its own list (and the count with it)
      if (this.showShell && this.$route.name !== "approval") this.refreshApprovalCount();
    },
    async refreshSession() {
      // live notifications need a login token (see main.js)
      if (this.$socket && !this.$socket.connected) this.$socket.connect();
      try {
        const me = await fetchMe();
        this.$store.commit("SET_USER", { ...this.$store.getters.getUser, ...me });
      } catch (error) {
        // 401 (blocked account) is handled by the interceptor; anything else keeps the stored profile
      }
      if (!this.pageLoadsQueue(this.$route)) this.refreshApprovalCount();
    },
    pageLoadsQueue(route) {
      return ["home", "approval"].includes(route && route.name);
    },
    async refreshApprovalCount() {
      const role = this.$store.getters.getUser?.role;
      if (!hasWorkQueue(role)) return;
      try {
        const queue = await fetchMyWork(role);
        this.$store.commit("SET_APPROVAL_COUNT", uniqueByRequest(queue).length);
      } catch (error) {
        console.error("Error counting approvals:", error);
      }
    },
    handleLogout() {
      if (this.$socket) this.$socket.disconnect();
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
  },
};
</script>
